import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Import des pages
import Homepage from './pages/Homepage';
import StatsPage from './pages/Stats';
import { SearchPage, AccountPage } from './pages/Otherpages';
import FlashcardApp from './FlashcardApp';
import Login from './pages/Login';
import Settings from './pages/Settings';
import AIAssistant from './pages/AIAssistant';

// Import de la navigation et de l'authentification
import BottomNavigation from './components/BottomNavigation';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="min-h-screen bg-sand-50">
          <Routes>
            {/* Route publique pour le login */}
            <Route path="/login" element={<Login />} />
            
            {/* Routes protégées */}
            <Route 
              path="/" 
              element={
                <ProtectedRoute permission="review">
                  <Homepage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/stats" 
              element={
                <ProtectedRoute permission="stats">
                  <StatsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/review" 
              element={
                <ProtectedRoute permission="review">
                  <FlashcardApp />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/search" 
              element={
                <ProtectedRoute permission="library">
                  <SearchPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/account" 
              element={
                <ProtectedRoute>
                  <AccountPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/settings" 
              element={
                <ProtectedRoute permission="settings">
                  <Settings />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/ai-assistant" 
              element={
                <ProtectedRoute permission="assistant">
                  <AIAssistant />
                </ProtectedRoute>
              } 
            />
          </Routes>
          <BottomNavigation />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;